import { DocumentNotifyTypeEnum } from 'shared/enums/document-notify-type-enum';

export type INotificationCardProps = {
    index: number,
    id: number,
    time: Date,
    clickAction: any,
    faId?: number,
    documentId?: number,
    documentTitle?: string,
    documentNotifyType?: DocumentNotifyTypeEnum
}

export const getCardBodyText = (props: INotificationCardProps): string => {
    if (typeof (props.faId) === 'number' && props.faId > 0) {
        return 'You have been assigned to complete a Fatigue Assessment form. Click here to fill and submit the form.';
    }

    if (typeof (props.documentId) === 'number' && props.documentId > 0 && props.documentNotifyType === DocumentNotifyTypeEnum.InitialDocument) {
        return `${props.documentTitle} has been published. Please read and acknowledge the document.`;
    }

    if (typeof (props.documentId) === 'number' && props.documentId > 0 && props.documentNotifyType === DocumentNotifyTypeEnum.VersionUpdate) {
        return `New version added for ${props.documentTitle}. Please read and acknowledge the new version.`;
    }

    if (typeof (props.documentId) === 'number' && props.documentId > 0 && props.documentNotifyType === DocumentNotifyTypeEnum.Rescinded) {
        return `${props.documentTitle} has been rescinded. Please read and acknowledge the replacement document.`;
    }

    if (typeof (props.documentId) === 'number' && props.documentId > 0 && props.documentNotifyType === DocumentNotifyTypeEnum.Restored) {
        return `The previous version of ${props.documentTitle} has been restored. Please review the document.`;
    }

    if (typeof (props.documentId) === 'number' && props.documentId > 0 && props.documentNotifyType === DocumentNotifyTypeEnum.Review) {
        return `${props.documentTitle} is up for a periodic review. Please review and re-acknowledge.`;
    }

    return '';
}

export const getTimeDiffText = (props: INotificationCardProps): string => {
    let timeDiff = ((new Date()).valueOf() - new Date(props.time).valueOf()) / 60000;
    let timeDesc = 'day';

    if (timeDiff < 1) {
        return 'Just now';
    }

    if (timeDiff < 60) {
        timeDesc = 'minute';
    }

    else if ((timeDiff = timeDiff / 60) < 24) {
        timeDesc = 'hour';
    }

    else {
        timeDiff = timeDiff / 24;
    }

    timeDiff = Math.round(timeDiff);

    if (timeDiff !== 1) {
        timeDesc += 's';
    }

    return timeDiff + ' ' + timeDesc;
}